import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	classificationFieldLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectDefaultClassificationOption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noClassificationOption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectDefaultClassificationOptionGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noClassificationOptionGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	classificationFieldLabel: {
		id: 'issue-create-commons.data-classification-field.classification-field-label',
		defaultMessage: 'Classification level',
		description: 'This will be used as the field name for classification field',
	},
	projectDefaultClassificationOption: {
		id: 'issue-create-commons.data-classification-field.project-default-classification-option',
		defaultMessage: 'Project default',
		description: 'This is the project default option',
	},
	noClassificationOption: {
		id: 'issue-create-commons.data-classification-field.no-classification-option',
		defaultMessage: 'Project default - No classification',
		description: 'This is no classification option',
	},
	projectDefaultClassificationOptionGalaxia: {
		id: 'issue-create-commons.data-classification-field.project-default-classification-option-galaxia',
		defaultMessage: 'Space default',
		description: 'This is the project default option',
	},
	noClassificationOptionGalaxia: {
		id: 'issue-create-commons.data-classification-field.no-classification-option-galaxia',
		defaultMessage: 'Space default - No classification',
		description: 'This is no classification option',
	},
});
export default messages;
